<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
  <h2 mat-dialog-title class="m-0 fs-6 fw-bold text-dark pe-4">
    Référence de {{ partenaire.collaborateur_name }} chez {{ partenaire.compagnie_name }}
  </h2>
  <button mat-icon-button mat-dialog-close (click)="onClose()" aria-label="Fermer">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content id="modalDialog" #modalDialog [formGroup]="partForm" class="p-4 bg-white custom-dialog-content">
  <div class="d-flex flex-column gap-3">
    
    <!-- État & Toggle -->
    <div class="d-flex align-items-center justify-content-between p-2 rounded-2 bg-light border">
      <span class="small fw-semibold text-secondary text-uppercase tracking-wider">État du partenariat</span>
      <mat-slide-toggle formControlName="join" labelPosition="after" #toggleJoin class="custom-toggle">
        <span class="small fw-medium text-dark">{{ toggleJoin.checked ? 'Associé' : 'Dissocié' }}</span>
      </mat-slide-toggle>
    </div>

    <!-- Saisie Code -->
    <div class="w-100">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Code</mat-label>
        <input matInput type="text" formControlName="code" (change)="checkValue('code', code.value, 'code')" #code placeholder="Entrez le code">
        @if (partForm.get('code')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (partForm.get('code')?.hasError('exist')) {<mat-error>Ce code est déjà attribué</mat-error>}
      </mat-form-field>
    </div>

    <!-- Saisie Format Catégorie -->
    <div class="w-100">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Format Catégorie</mat-label>
        <input matInput type="text" formControlName="categorie" #cat placeholder="Entrez le format de la catégorie (ex: 00, 100, 200)">
        @if (partForm.get('categorie')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <!-- Guide des variables de formatage (Badges épurés) -->
    <div class="w-100 p-3 rounded-3 bg-light border">
      <span class="d-block small fw-bold text-secondary text-uppercase tracking-wider mb-2">Variables de formatage disponibles</span>
      <div class="d-flex flex-wrap gap-2 mb-3">
        <span class="format-guide-badge">Digits année <code class="ms-1">{{ '{A:4}' }}</code></span>
        <span class="format-guide-badge">Code Bureau (CB) <code class="ms-1">{{ '{B:true/false}' }}</code></span>
        <span class="format-guide-badge">Digits code <code class="ms-1">{{ '{R:4}' }}</code></span>
        <span class="format-guide-badge">Digits catégorie <code class="ms-1">{{ '{C:2}' }}</code></span>
        <span class="format-guide-badge">Digits compteur <code class="ms-1">{{ '{I:4}' }}</code></span>
        <span class="format-guide-badge">Alias <code class="ms-1">{{ '{N:true/false}' }}</code></span>
      </div>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Police</mat-label>
        <input matInput type="text" [readonly]="code.value == '' && cat.value == ''" formControlName="police" placeholder="Entrez le format de police">
        @if (partForm.get('police')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <!-- Aperçu dynamique du résultat -->
    <div class="preview-box p-3 rounded-3 text-center border-dashed">
      <span class="d-block small text-muted text-uppercase tracking-wider mb-1">Aperçu du format généré</span>
      <h6 class="m-0 fw-bold text-primary fs-5">{{ policeValue }}</h6>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-light m-0 gap-2">
  <button mat-stroked-button mat-dialog-close color="warn" class="px-4" (click)="onClose()">Fermer</button>
  <button [disabled]="partForm.invalid" type="button" mat-flat-button color="primary" class="px-4" (click)="onSend()">Enregistrer</button>
</mat-dialog-actions>
